import React, { Component } from "react";

export default class TextEntry extends Component {
    render() {
        const input = this.props.input;
        const disabled = this.props.disabled;
        const inputIndex = this.props.inputIndex;
        const onFocus = this.props.onFocus;

        return (
<div className="text-entry">
    <div><input type="text" className={inputIndex === 0 ? "current" : ""}  onFocus={(e) => onFocus(e, 0)} maxLength="1" disabled={disabled} value={input[0]} /></div>
    <div><input type="text" className={inputIndex === 1 ? "current" : ""}  onFocus={(e) => onFocus(e, 1)} maxLength="1" disabled={disabled} value={input[1]} /></div>
    <div><input type="text" className={inputIndex === 2 ? "current" : ""}  onFocus={(e) => onFocus(e, 2)} maxLength="1" disabled={disabled} value={input[2]} /></div>
    <div><input type="text" className={inputIndex === 3 ? "current" : ""}  onFocus={(e) => onFocus(e, 3)} maxLength="1" disabled={disabled} value={input[3]} /></div>
    <div><input type="text" className={inputIndex === 4 ? "current" : ""}  onFocus={(e) => onFocus(e, 4)} maxLength="1" disabled={disabled} value={input[4]} /></div>
    <div><input type="text" className={inputIndex === 5 ? "current" : ""}  onFocus={(e) => onFocus(e, 5)} maxLength="1" disabled={disabled} value={input[5]} /></div>
    <div><input type="text" className={inputIndex === 6 ? "current" : ""}  onFocus={(e) => onFocus(e, 6)} maxLength="1" disabled={disabled} value={input[6]} /></div>
    <div><input type="text" className={inputIndex === 7 ? "current" : ""}  onFocus={(e) => onFocus(e, 7)} maxLength="1" disabled={disabled} value={input[7]} /></div>
    <div><input type="text" className={inputIndex === 8 ? "current" : ""}  onFocus={(e) => onFocus(e, 8)} maxLength="1" disabled={disabled} value={input[8]} /></div>
</div>
            );
    }
}
